import Api from './Api';

class LogicBaseCommentLikeApi extends Api {
  url = 'logicbasecommentlikes';
}

const singleton = new LogicBaseCommentLikeApi();
export default singleton;
